import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    gap: '1rem',
  },
  textField: {
    width: '31%',
  },
}));

export default useStyles;
